import React from "react";

import { ContactCardProps } from "@models/shared/shared.model";

const ContactCard: React.FC<ContactCardProps> = ({
  contactDetail,
  handleNavigate,
}) => {
  return (
    <li data-testid="contactCard-test">
      <button
        className="btn fg-btn fg-date-btn fg-btn-contact-user"
        onClick={handleNavigate}
        data-testid="contactCard-button"
      >
        <i className="fa-solid fa-user-tie"></i>

        <span className="fg-date-btn-desc">
          <span className="fg-fw-300">{contactDetail?.name}</span>
        </span>
      </button>
    </li>
  );
};

export default ContactCard;
